// import React from "react";
import Button from "../../components/button/Button";
import SellGCardImage from "../../assets/SellGCardImage.webp";
import SellGCardImage2 from "../../assets/SellGCardImage2.webp";
import AmazonCard from "../../assets/AmazonCard.svg";
import GoogleCard from "../../assets/GoogleCard.svg";
import ItuneCard from "../../assets/ItuneCard.svg";
import NetflixCard from "../../assets/NeflixCard.svg";
import VisaCard from "../../assets/VisaCard.svg";
import XBoxCard from "../../assets/XBoxCard.svg";

import BulkCard from "../../assets/bulkCard.webp";
import mobile from "../../assets/mobile.png";
import mobile2 from "../../assets/mobile2.png";
import mobile3 from "../../assets/mobile3.png";
import ColoredLogo from "../../assets/ColoredLogo.svg";
import "./sellgiftcard.css";
import NavBar from "../../Nav Bar/NavBar";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
import SEO from "../../components/seo/seo";

const SellGiftCard = () => {
  return (
    <>
    <SEO
        title="Sell Gift Cards | Get Instant Rewards | GiftCard8"
        description="Exchange your gift cards for cash at the best rates and earn rewards instantly. Join GiftCard8 today!"
        keywords="sell gift cards, exchange gift cards, gift card trading, best gift card rates, GiftCard8"
        image="../../assets/SellGCardImage.png"
        url="https://giftcard8.com/sell-gift-cards"
      />
      <NavBar linkColor="#000" logo={ColoredLogo} bg="#fff" />
      <div className="container main_section" style={{ marginTop: "10%" }}>
        <div className="row py-4 p-md-5 justify-content-center sellGCImg1">
          <div className="col-md-6 d-flex flex-column justify-content-center py-3 text-center text-md-start">
            <h1 className="fs-1 fw-bold text-start mb-4">
              Sell Gift Cards and Get Rewards
            </h1>
            <p className="text-start">
              It only takes a few seconds to exchange your gift cards for cash
              at the best price and get generous cash rewards.
            </p>
            <Button
              className="w-50 hover-effect mt-4 mb-5"
              style={{ border: "1px solid #fff" }}
              actionType="redirect"
              redirectUrl="https://dashboard.giftcard8.com/account"
              id="sellNowBtn"
            >
              Get Started
            </Button>
          </div>
          <div className="col-md-6 d-flex mx-0">
            <LazyLoad>
              <img
                src={SellGCardImage}
                alt="GCImage"
                className="img-fluid hover-effect"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </LazyLoad>
          </div>
        </div>
      </div>

      <div className="container">
        <hr style={{ marginTop: "3%", border: "2px solid #777" }} />
      </div>
      <div className="container second_section my-5">
        <div className="row py-4 p-md-5 sellGCImg1">
          <div className="col-md-6">
            <LazyLoad>
              <img
                src={SellGCardImage2}
                alt="GCImage"
                className="img-fluid hover-effect"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </LazyLoad>
          </div>
          <div className="col-md-6 d-flex flex-column justify-content-center mt-5 px-3 text-center text-md-start">
            <h1 className="fs-1 fw-bold text-start mb-4">
              The Best Platform for Gift Card Trading
            </h1>
            <p className="text-start text-muted">
              GiftCard8 knows the needs of customers, so it has created a safe,
              fast and efficient gift card exchange platform for you, and has
              prepared generous cash rewards and exciting activities for you.
              Looking forward to your joining!
            </p>
            <Button
              className="w-50 hover-effect my-4"
              actionType="redirect"
              redirectUrl="https://dashboard.giftcard8.com/account"
              id="joinNowBtn"
            >
              Join Now
            </Button>
          </div>
        </div>
      </div>
      <div className="container">
        <hr style={{ marginTop: "3%", border: "2px solid #777" }} />
      </div>
      <div className="carousel-wrapper mt-5 my_carosal">
        <div className="carousel-container">
          {/* Duplicate slides for seamless looping */}
          {[...Array(2)].map((_, index) => (
            <div key={index} className="carousel-slide">
              <div className="card p-3">
                <img
                  src={GoogleCard} // Replace with actual image URL
                  alt="Google Play"
                  className="img-fluid"
                />
              </div>
              <div className="card p-3">
                <img
                  src={NetflixCard} // Replace with actual image URL
                  alt="Netflix"
                  className="img-fluid"
                />
              </div>
              <div className="card p-3">
                <img src={VisaCard} alt="Spotify" className="img-fluid" />
              </div>
              <div className="card p-3">
                <img src={ItuneCard} alt="iTunes" className="img-fluid" />
              </div>
              <div className="card p-3">
                <img src={AmazonCard} alt="Spotify" className="img-fluid" />
              </div>
              <div className="card p-3">
                <img src={XBoxCard} alt="iTunes" className="img-fluid" />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="container d-flex flex-column justify-content-center align-items-center py-5 my-5 recomend">
        <h1 className="fs-1 fw-bold my-4">Recommended Gift Cards</h1>
        <p className="mb-4 text-center text-muted w-75">
          GiftCard8's exchange rate is higher than the market average, and more
          than 100 brands of gift cards can be exchanged, including Steam,
          AppleGoogle Play, Amazon, Apple Store, Footlocker, Visa, eBay,
          Sephora, etc.
        </p>
        <Link
          to="/best-rates"
          onClick={() => window.scrollTo(0, 0)}
          style={{ textDecoration: "none" }}
          className="w-100"
        >
          <div className="d-flex justify-content-center align-items-center">
            <Button className="w-25 responsive-button hover-effect" id="checkExchangeRateBtn">
              Check the Exchange Rate
            </Button>
          </div>
        </Link>
      </div>
      <div className="container">
        <hr style={{ marginTop: "3%", border: "2px solid #777" }} />
      </div>
      <div className="container d-flex justify-content-center align-items-center my-5 SGSection">
        <div
          className="card text-center shadow-lg"
          style={{
            borderRadius: "20px",
            overflow: "hidden",
            width: "100%",
          }}
        >
          {/* Background Image Section */}
          <div className="position-relative bulkCard">
            <img
              src={BulkCard} // Replace with your image URL
              alt="Background"
              className="w-100 h-100 SGSection"
              style={{ objectFit: "cover" }}
            />
            {/* Overlay Text */}
            <div
              className="position-absolute bottom-0 start-50 translate-middle-x text-dark bg-white w-75 rounded-4 my-5 bulk_content"
              style={{ zIndex: 1 }}
            >
              <div className="py-3 px-3 bulk_text">
                <h1 className="fw-bold my-4 fs-1">
                  Enjoy Premium VIP Benefits
                </h1>
                <p className="mb-4">
                  Unlock exclusive VIP perks with just one click! Tap the button
                  below to upgrade to VIP and elevate your experience instantly.
                </p>
                <div className="w-100 d-flex justify-content-center align-items-center">
                  <Button
                    className="w-25 hover-effect contBtn"
                    actionType="redirect"
                    redirectUrl="https://dashboard.giftcard8.com/account"
                    id="joinNowBtn"
                  >
                    Join Now
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <hr style={{ marginTop: "3%", border: "2px solid #777" }} />
      </div>
      <div className="container my-5">
        <h1 className="fw-bold text-center fs-1">
          How to sell gift cards on GiftCard8?
        </h1>
      </div>
      <div className="container my-5 last_section">
        <div className="row justify-content-center position-relative">
          {/* Column 1 */}
          <div className="col-12 col-md-4 d-flex flex-column align-items-center text-center my-3 position-relative">
            <LazyLoad>
              <img
                src={mobile}
                alt="mobile"
                className="img-fluid hover-effect"
              />
            </LazyLoad>
            <h3 className="fw-bold my-4">1. Create your account</h3>
            <p>
              When you use a new APP, you need to register your account, create
              your own user ID and password, and remember it.
            </p>
            {/* Vertical Line */}
            <div className="vertical-line d-none d-md-block"></div>
          </div>
          {/* Column 2 */}
          <div className="col-12 col-md-4 d-flex flex-column align-items-center text-center my-3 position-relative">
            <LazyLoad>
              <img
                src={mobile2}
                alt="mobile"
                className="img-fluid hover-effect"
              />
            </LazyLoad>
            <h3 className="fw-bold my-4">2. Submit your order</h3>
            <p>
              Upload your gift card and attach a clear card code, we will give
              you feedback immediately.
            </p>
            {/* Vertical Line */}
            <div className="vertical-line d-none d-md-block"></div>
          </div>
          {/* Column 3 */}
          <div className="col-12 col-md-4 d-flex flex-column align-items-center text-center my-3">
            <LazyLoad>
              <img
                src={mobile3}
                alt="mobile"
                className="img-fluid hover-effect"
              />
            </LazyLoad>
            <h3 className="fw-bold my-4">3. Withdraw your funds</h3>
            <p>
              After the order is successful, the system will automatically
              transfer the amount you deserve to your wallet. You need to bind
              your bank and then withdraw your funds.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default SellGiftCard;
